module.exports = __webpack_public_path__ + "static/img/hysteroscope-detail-2.6eff0ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-detail-2.jpg
// module id = 9eXK
// module chunks = 51